import { useCallback, useState } from 'react';
import { useApi } from '../api';

export interface BulkPublishEmbedProductResult {
  product_id: string;
  product_name: string;
  status: 'published' | 'already_published' | 'failed';
  error_code?: string;
  error_detail?: string;
}

export interface BulkPublishEmbedResult {
  results: BulkPublishEmbedProductResult[];
  published_count: number;
  already_published_count: number;
  failed_count: number;
}

interface UseBulkPublishEmbedReturn {
  bulkPublish: (productIds: string[]) => Promise<BulkPublishEmbedResult | null>;
  loading: boolean;
}

export const useBulkPublishEmbed = (): UseBulkPublishEmbedReturn => {
  const api = useApi();
  const [loading, setLoading] = useState(false);

  const bulkPublish = useCallback(
    async (productIds: string[]): Promise<BulkPublishEmbedResult | null> => {
      setLoading(true);
      try {
        const data = await api.post('/products/embeds/bulk-publish', { product_ids: productIds });
        return data as BulkPublishEmbedResult;
      } catch {
        return null;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return { bulkPublish, loading };
};
